import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 mt-10 mb-8" }
const _hoisted_2 = { class: "flex items-center justify-between mb-4" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "bg-white rounded-lg border border-gray-300 overflow-auto" }
const _hoisted_5 = { class: "w-full p-4 flex justify-end" }
const _hoisted_6 = { class: "p-input-icon-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Objetos",
            en: "Objects",
          })), 1),
      _createVNode(_component_Button, {
        label: _ctx.$t('labels.generic', { pt: 'Baixar', en: 'Download' }),
        icon: "pi pi-download",
        class: "p-button-sm btn-primary h-9",
        loading: _ctx.btnLoading,
        onClick: _ctx.downloadCSV
      }, null, 8, ["label", "loading", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          _createElementVNode("i", {
            class: "pi pi-search text-h-primary-500 cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.objectsPaginated()))
          }),
          _createVNode(_component_InputText, {
            modelValue: _ctx.objectName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.objectName) = $event)),
            placeholder: "Pesquisar por objetos",
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.objectsPaginated()), ["enter"]))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode(_component_Table, {
        slotData: _ctx.objects,
        columns: _ctx.columns,
        loading: _ctx.loader,
        params: _ctx.params,
        filters: _ctx.filters,
        hasStatus: false,
        hasActions: false,
        onOnPaginate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.paginate($event)))
      }, null, 8, ["slotData", "columns", "loading", "params", "filters"])
    ])
  ]))
}